import { isPlatformBrowser } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnInit, Output, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/modules/auth/shared/auth.service';
import { LocalStoreService } from '../../services/local-store.service';
import { RealtimeDatabaseService } from '../../services/realtime-database.service';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-right-sidenav',
  templateUrl: './right-sidenav.component.html',
  styleUrls: ['./right-sidenav.component.scss'],
  providers: [MessageService]
})
export class RightSidenavComponent implements OnInit {
  subscription: Subscription;
  @Output() closeRightSidenav = new EventEmitter();

  @Input() userBalance;
  @Input() username;

  balanceSubscription: Subscription;

  constructor(
    public router: Router,
    private authService: AuthService,
    private rdService: RealtimeDatabaseService,
    private messageService: MessageService,
    private translateService: TranslateService
  ) {
    authService.event.subscribe((data) => {
      this.username = data
    });
  }

  getUserBalance() {
    this.balanceSubscription = this.rdService.getUserBalance().subscribe((res) => {
      if (this.userBalance && res[0] > this.userBalance) {
        this.messageService.clear();
        this.messageService.add({
          severity: 'success', summary: 'Success', life: 30000,
          detail: this.translateService.instant('ALERT.MONEY_HAS_BEEN_DEPOSITED')
        });
      }
      this.userBalance = res ? res[0] : '';
    });
  }

  ngOnInit(): void {
    this.authService.currentAuthStatus.subscribe((authStatus) => {
      if (authStatus) {
        this.getUserBalance();
      } else {
        this.balanceSubscription && this.balanceSubscription.unsubscribe();
      }
    });
  }

  ngOnDestroy(): void {
    this.subscription && this.subscription.unsubscribe();
    this.balanceSubscription && this.balanceSubscription.unsubscribe();
  }

  logOut() {
    this.balanceSubscription && this.balanceSubscription.unsubscribe();
    this.authService.logOut();
  }
}
